import gql from 'graphql-tag';
import { convertFilterRequestUrl } from '../../utils/utils';

export default ({ page, size, filter, sort }) => {
  const sortStr = sort ? `, sort: ${sort}` : '';
  const filterStr = filter
    ? `, filter: ${convertFilterRequestUrl(filter, ['accountType', 'accountSubType', 'salesChannel', 'marketSegment'])}`
    : '';
  const getNewCustomerReport = `getNewCustomerReport(page: ${page}, size: ${size}${sortStr}${filterStr})`;
  return gql`
    query {
      ${getNewCustomerReport} {
        id
        company
        firstName
        lastName
        accountType
        accountSubType
        salesChannel
        marketSegment
        country
        state
        city
        effectiveDate
        status
        commercialName
        rfc
        customAccountType
      }
    }
  `;
};
